import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function EditCleaningBusiness() {
  const { id } = useParams();
  const navigate = useNavigate();


  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  /* =========================
     LOAD CLEANING BUSINESS
  ========================= */
  useEffect(() => {
    async function load() {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(
          `${API_BASE_URL}/api/cleaning/business/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!res.data?.success || !res.data.business) {
          setError("Business not found.");
          setLoading(false);
          return;
        }

        const b = res.data.business;

        // 🔑 NORMALISE ALL FIELDS FROM DB
        setFormData({
          business_title: b.business_title ?? "",
          business_description: b.business_description ?? "",
          price: b.price ?? "",
          yearly_revenue: b.yearly_revenue ?? "",
          clients_count: b.clients_count ?? "",
          suburb: b.suburb ?? "",
          state: b.state ?? "",
          postcode: b.postcode ?? "",
          vehicle_included: Number(b.vehicle_included ?? 0),
          vehicle_details: b.vehicle_details ?? "",
          trailer_included: Number(b.trailer_included ?? 0),
          trailer_details: b.trailer_details ?? "",
          equipment_included: Number(b.equipment_included ?? 0),
          equipment_details: b.equipment_details ?? "",
          enquiry_only: Number(b.enquiry_only ?? 0),
        });
      } catch (err) {
        console.error("LOAD ERROR:", err);
        setError("Failed to load business.");
      }
      setLoading(false);
    }

    load();
  }, [API_BASE_URL, id]);

  /* =========================
     UPDATE FIELD
  ========================= */
  const updateField = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  /* =========================
     SAVE CHANGES
  ========================= */
const saveChanges = async (e) => {
  e.preventDefault();
  if (saving) return;   // 🔒 stop spam clicks
  setSaving(true);
  setError("");

  // Simple safety checks
if (!formData.business_title?.trim()) {
  setError("Business title is required.");
  setSaving(false);
  return;
}

if (Number(formData.price) <= 0) {
  setError("Price must be greater than 0.");
  setSaving(false);
  return;
}

if (Number(formData.yearly_revenue) <= 0) {
  setError("Yearly revenue must be greater than 0.");
  setSaving(false);
  return;
}

    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user"));

      const payload = {
        user_id: user.id, // ✅ REQUIRED
        ...formData,
      };

      const res = await axios.put(
        `${API_BASE_URL}/api/cleaning/business/edit/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data?.success) {
        alert("Business updated successfully.");
        navigate("/my-listings");
      } else {
        setError(res.data?.message || "Save failed.");
      }
    } catch (err) {
      console.error("SAVE ERROR:", err);
      setError("Server error saving changes.");
    }

    setSaving(false);
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading…</p>;
  if (!formData) return <p style={{ color: "red" }}>{error}</p>;

  const input = {
    width: "100%",
    padding: "10px",
    marginTop: "6px",
    marginBottom: "14px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    fontSize: "1rem",
  };

  return (
    <div style={{ maxWidth: 800, margin: "40px auto", padding: 25 }}>
      <h1>Edit Cleaning Business</h1>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={saveChanges}>
        <label>Business Title</label>
        <input name="business_title" value={formData.business_title} onChange={updateField} style={input} />

        <label>Description</label>
        <textarea name="business_description" value={formData.business_description} onChange={updateField} style={input} />

        <label>Price ($)</label>
        <input type="number" name="price" min="1" value={formData.price} onChange={updateField} style={input} />


        <label>Yearly Revenue</label>
        <input type="number" name="yearly_revenue" min="1" value={formData.yearly_revenue} onChange={updateField} style={input} />

        <label>Clients Count</label>
        <input type="number" name="clients_count" min="1" value={formData.clients_count} onChange={updateField} style={input} />

        <label>Suburb</label>
        <input name="suburb" value={formData.suburb} onChange={updateField} style={input} />

        <label>State</label>
        <input name="state" value={formData.state} onChange={updateField} style={input} />

        <label>Postcode</label>
        <input name="postcode" value={formData.postcode} onChange={updateField} style={input} />

        <button disabled={saving} style={{ width: "100%", padding: 14 }}>
          {saving ? "Saving…" : "Save Changes"}
        </button>
      </form>
    </div>
  );
}
